import { Action } from '@ngrx/store';
import { RecipeFormValues } from '../../location-specification/models/form-values';
import { OrderLoad, OrderSummary } from '../models/orderSummary.model';
import * as fromAdditionalServices from '@ordersnproducts/modules/order-builder/modules/location-specification/reducers/additional-services.reducer';
import { UnitsOfMeasurement } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/units-of-measurement.model';

export enum BlkOrderActionTypes {
  START_LOADING = '[Order] Start loading orders',
  REQUEST = '[Order] Request',
  LOAD_SUMMARY_FORM = '[Order] Load summary from form',
  REQUEST_COMPLETE = '[Order] Request complete',
  LOADING_COMPLETE = '[Order] Finish loading orders',
  RESET = '[Order] Reset',
}

export class BlkOrdersStarLoadAction implements Action {
  readonly type = BlkOrderActionTypes.START_LOADING;

  constructor() {}
}

export class BlkOrdersFinishLoadAction implements Action {
  readonly type = BlkOrderActionTypes.LOADING_COMPLETE;

  constructor() {}
}

export class BlkGetOrderAction implements Action {
  readonly type = BlkOrderActionTypes.REQUEST;

  constructor(
    public payload: { orderId: number; formId: number; formValues: RecipeFormValues; units: UnitsOfMeasurement[] },
  ) {}
}

export class BlkLoadSummaryFromFormAction implements Action {
  readonly type = BlkOrderActionTypes.LOAD_SUMMARY_FORM;

  constructor(
    public payload: {
      orderId: number;
      formId: number;
      formValues: RecipeFormValues;
      additionalServices: fromAdditionalServices.State;
      units: UnitsOfMeasurement[];
    },
  ) {}
}

export class BlkOrderLoadCompleteAction implements Action {
  readonly type = BlkOrderActionTypes.REQUEST_COMPLETE;

  constructor(public payload: { order: OrderSummary; items: OrderLoad[]; formId: number }) {}
}

export class BlkOrderResetAction implements Action {
  readonly type = BlkOrderActionTypes.RESET;

  constructor() {}
}

export type BlkOrderActions =
  | BlkGetOrderAction
  | BlkOrderLoadCompleteAction
  | BlkOrderResetAction
  | BlkLoadSummaryFromFormAction
  | BlkOrdersStarLoadAction
  | BlkOrdersFinishLoadAction;
